<template>
    <!-- <pre>{{ addressdelivery }}</pre> -->
    <div>
        <div class="relative p-4 wrapper-track">
            <template v-if="title != null">
                <div style="pointer-events: none;">
                    <a-image :preview="{ visible: false }" class="image-center banner" alt="มหายันต์ลูกกอ"
                        src="https://namahayan.blob.core.windows.net/assets/banner.webp"></a-image>
                </div>
            </template>

            <div v-for="(item_listtrack, idx) of listtrack" :key="`v-list-item-${idx}`">
                <div class="text-lg font-bold item-menu" @click="getaddress(item_listtrack.AdditionalTage)"> {{
                    item_listtrack.AdditionalTage }}</div>
            </div>
        </div>
    </div>
    <div v-if="false && isclickdetail && listproductpreview" class="relative p-4 wrapper-track">
        <a-steps direction="vertical" :current="current_status">
            <a-step v-if="listproductpreview" :title="'ขอมูลสินค้า'" class="title-step">
                <template #description>
                    <pre>(ข้อมูลสินค้าที่อยู่ใน {{ listproductpreview[0]?.PD_AdditionalTage }})</pre>
                    <span v-show="current_status = 2"></span>
                    <div v-for="(itempreview, idx) of listproductpreview" :key="`v-list-item-${idx}`">
                        <div>- {{ itempreview.CustomerProductsType + itempreview.CustomerProductsSize +
                            itempreview.HeartYanName }}</div>
                    </div>
                </template>
            </a-step>
            <a-step v-if="listproductpreview[0]?.TrackVideoId && listproductpreview[0]?.PD_AdditionalTage"
                :title="'วีดีโอ(แพ็คสินค้า)'" class="title-step">
                <template #description>
                    <span v-show="current_status = 1"></span>
                    <!-- <video ref="videoPlayer"
                        :src="'https://drive.google.com/uc?export=download&id=' + listproductpreview[0]?.TrackVideoId"
                        autoplay loop muted playsinline type='video/mp4'></video> -->

                    <u>
                        <youtube-outlined class="m-2" :style="{ fontSize: '20px', color: '#ff0000a3' }" />
                        <a class="mt-4"
                            :href="'https://drive.google.com/file/d/' + listproductpreview[0]?.TrackVideoId + '/view'">
                            <div class="video-preview">
                                <img :src="'https://namahayan.blob.core.windows.net/trackimage/' + listproductpreview[0]?.PD_AdditionalTage + '.jpeg'"
                                    alt="Video Preview">
                                <div class="play-button"></div>
                            </div>
                            <youtube-outlined :style="{ fontSize: '20px', color: '#ff0000a3' }" />
                            คลิ๊กดู
                            วีดีโอ(แพ็คสินค้า)
                        </a>
                    </u>

                </template>
            </a-step>
            <a-step v-if="listproductpreview[0]?.TrackVideoId && listproductpreview[0]?.PD_AdditionalTage"
                :title="'ภาพถ่าย(แพ็คสินค้า)'" class="title-step">
                <template #description>
                    <span v-show="current_status = 4"></span>
                    <a-image :preview="false" :width="auto"
                        :src="'https://namahayan.blob.core.windows.net/trackimage/' + listproductpreview[0]?.PD_AdditionalTage + '.jpeg'" />

                </template>
            </a-step>
            <a-step title="ชื่อผู้รับ">
                <template #description>
                    <div> 
                        <div v-if="addressdelivery.length > 0">
                            <span v-show="current_status = 5"></span>
                            <br>
                            <font-awesome-icon icon="fa-solid fa-user" class="pr-2" />
                            <br>

                            <a-typography-paragraph
                                :copyable="{ text: listproductpreview[0]?.PD_TrackingNo, onCopy: iscopy }">
                                Tracking : {{ listproductpreview[0]?.PD_TrackingNo }}
                            </a-typography-paragraph>
                            <div v-show="iscopyfact" class="p-4">
                                <a href="https://track.thailandpost.co.th/"><img data-v-2e7878f9=""
                                        src="data:image/png;base64,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"
                                        border="0" style="width: 160px;background-color: red;padding: 10px;"></a>
                            </div>
                            <div v-show="iscopyfact" class="p-4">
                                <a href="https://track.thailandpost.co.th/"><img data-v-2e7878f9=""
                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAi4AAABYBAMAAAAggGEZAAAAJFBMVEVHcEz///////////////////////////////////////////8Uel1nAAAAC3RSTlMAvX5A1xBZ75kwIDurKhwAAAw+SURBVHja7ZzPcxNHFsfbkkcryRfJC4REF1kmdlhdFLxQbHwhUKacnYs2ccVU5SLMbsGiy4atpAi6mIJAbXQRhKpQ5YsSqliquFjSrCXof267X/+Y7pkeaX7IcgXcB9D86J7uz/S3X7/XPUboXUy5YrH4ITpO3pTGGA+OMRxzmR2X58WkqYBiZjzdlbW4Lk8qw8Jc5FHiCS/khJ/LTrHYQffloyeX9dTGyVIfVeNkcx7V3Uq4JSjNWYj81teV8t9qV/5MztRQSVzshSjMut5KBqYzFz3PcLGr1uEQuFxSL2RwdC4k18NEXC7lI4O9XNNrcAhcyuqF7VhcEoopspA2/+F9/vS5OHX1Qjsml2Riiiakb//kf/z0uXyhXbDjckkkpihCcpZND586l8tad0E4PpcEYgovJDBClv/RL9ZIukDejPNTEi4ovcbSZ57zcLKOfqb/LZFiT4XW0a1GAjGFFBIYIevWg4A6rBIs6ni8cCiz1r+RUj8Of7u1eqobW0zhhARG6Jx9NaAGWXLLLjpsLjlS0x+iZLBWnbNxxRRGSGCEfvsA3wmqQJvL/rdKpVL2cLlFRobTzIqlyGUYo9Lkx4rb38kdn4tDeg8b3V/sVCpECeS40pUWm76fPDv1qoR7Qrr5C+SU8gAJBm/GFdNEIYER+pr0xlF9jE9zTwye+zqXVVbIT+JsHxqvjJ/5Nrvjqqen/Z2eLLBxl0mU4BuJx+FaFnKxXpqDUVl5gAIGxxTTBCGBEUqfwZ4BREtzooJ+LltifCoHcbkpnrShcYFprsYlLTwExoXhBFCoiQO4AJh4YhorJDBC+aWWaJk57ZHLDSMXS9ZmFMAl45nOiZzrPi5zwkMALhd5Lvo+rFYgFwATT0zBQuJGiLXto+Dxjb66upFL1i1s18yl6d5RUHO2fVy+Eb0SuDQVHzOFg7kwMHHEFCgkboTYwZ0x474NlTJxea05gwYulvLsgZqz5OPSFJ4TcLGVfpgdx4WDiS6mACGBEXoqppm97hhziAO5tGVxvbqRi9Kh2JlgLlWNi+zTXGHBXDiY6GIyCUkaIZOLazBHAVzo+7mC0m2mAAMX8Jav1r8uiTIULj3pB9S4OVK5jG6c464TFLevGTwjmKhi8guJGaGHQa5ceC70hZKOkrP7AXa6yX9lRfNFTtI7nHFcnC43dmU2do/jIsFEE5NXSGCEckvKmcCZCxKtDOYC7d9qeLn0ziLrNhPa/8QYVfaMTOO4bIgfuyzz23FcJJhoYtKENDylGCF+qoHic3F074BxcR4hdNEesMYWxOixq+RMCdsfwKUhYBZYr+uP5eKCiSImVUiLHUSrrF3/AiXggn/0c8l3YUQnd7REY9d5E+WMsM1negFc5KkCmwQNO2O5KGDCi8kVkm6EFFMSkwuUtLjc8XBBLx9zw4zVKaHGJdXCTmMCl7bobcRp+L4+losCJryYuJC+va0boRC2aAKXqtBmXeUiujHnAmOQjwt6bss7grhUBZf8fbg4josKJqyYQEi9sx4jxNP3KD6Xba0QVu38kjKRC+ZyRrljEpeMjSdz0cCEExMRkt8IiUG3k4BLRnUDeLVTOAyXLI7ApYrDcNHAhBNTJ+MzQiL9FSXg4ro/o4hcqhG4pHE4LjqYMGK65DdCxkWLyFxycgyvRePSisBlPiwXD5jJYjrwGSGRfkSJuKD8Q9dbZtXOsEXoIaxgF4vFD0xc0jgCl9ehuXjATBRTT/HwtDRCCbmQZuwA8n3FjGaVuNSnGN/9p48LLdOBiGYILjRvv1KpheDiBTNJTGocRE27ybmQPkOb9Ib1974IMfVlyJy6OkYuaNK8TuEiH3uAooEZL6bOeuzuonB5LXDIH9fqgsOA/TfycGlz12adj3IKFywhdCdzeRN6GcILZqyYauuxu4vCRfbjJn+Dlr0h7uBcHBF6O5BhTC00vKdwaWiFT9CReOwbFBnMGDGZuYTqLkrV54UBs/nb32IiySqNrfH2DGSOsuhhB7z1Az7xucQD584ELns8nAG37KMYYALFhNZjdxfW3LW1Gp+MnWQLgzQzDXvfqcv3CA36N8+wL5UnV5yGNfSEW6Ecd8zytnw9tNEP6DKtj8sCn2ddk1HiyGACxOQYY5nhuouwqftiervIZs0NHjjqVWBK/y8xKdlcst3609exSM0OzEGcEzLQa7OsJSwlV+JTcz8X5t1twrLFRG8uCIxRTAfIjt1d2LtlHcDWA69tT2HqcU3ZxjDQA70DbZuE2D/VDuSiBXy7KC4Yg5g2cvG7i6Cxr6969D1R7a7qRsrpy54AITwpPr6IOSyWgQhetokLKkWvtAmMX0wN0xrSRlguVcllzvOS2xomxY0UC/DzunAwXueHuZYX4Xwwl60YlTaC8YjpwDTshvCMkFrjfW19keVOeTTZ9HrpGcmF1WAkpyC/eJuaDuaiPLaDkoHRxNSwDLOa8FsqrLY0MNc8ftUTrK3KZ0QD5Obem1gLSexKLlbbq4xngVzQl6L+JyNtAzHv3pBi+kjtiO4UOPwT8kuwSZqmV9Byd+/Uc5utEIktbzAUDP/oVm5JbIH+FPC5O6K5x7npDqS3yLVT7NOKYkfsqWYd8Uv22P9E2lATAAbElK5UbqOcbXKx4yXrQqVyQ5Fg/lxl5bxynVxeNiN/WTmrn/hqR886NtFyu1HrGgDGYRWxqvGN9O87BYGBBYDcY2PkAb3XYPCm2QXYQO87mEYWx4l2v/NgvrOmOOq+Q2B6JiHtomMwBicg/Fz3HQaz4Z/tvkHoGMzIH/Quo2MwxNeYez8nL5PA+DaS3UPHYEw7MsvoGIxhR2YPoWMwICQ9jPkWHYMxCWmqMnpR+/2CGXbntUWTKKmqwfVdztLdnOsi/B+QxKosD3t+3gh81IzBFNKeZYqpcdmjEfCIXIKitIfOxQemry7t7E6TC0GyH5lLQGz58Ll4wQzrW4qojp6Lc1RcvGAUIfXRNLm8phH7yFxw46i4eMAcuEKKHqmbo31C1PtnfjLNPoTOlO7WJZf8mpspLyLaf9G4DNgKSYEefiWGmdxns+OigxnWt8e+qrBcSJtglzZd5HA+VsREuVznKyS5YvHDVAtfBhQ2vlvXuaA/wGpl+jH/9t46wxdeqsPF3MqMwexmYllpL5dtHutri+8t0mtrXc7lmVj5Ipod2O5OELzh4cLKa4v90M/EpGrn/C27P+MeMxCL34NEXEpsiT4ry1qgLQIufMW5B1x6PFgKDsjIxGVO9F4eHRqxnbSz4KKCcer/Vb6+jM2FG/rX0tFyuWTlBo801rbtuoO9qqOq8El4voN0KYZVSA6mnFL3pcTl0lsp0UZlWs7yOeg5LherhB9dsCk1yuXyRfiIlohlRPexalzouEt7yfJ12k0Ipatrj3EjhWfHRQHzhgkpji+tcCnzg1824LCmcEHZA9gBUwAdQetrdAdVh/YIycUpFmk9GhmQGflZX6D35S+jmXJxwTis8w+ScYG2kYN8HaYuZZUL6sCtwGXAjFQexo28f15XnwObRO5pLMgZ+GzstBcME1IhKZcMP+BDi8qFtVzlkmbWy8dlQPfUFFgRREfD0yv1WXORYO7BlqVaUi5pOEjfb8kt+4KLJTYcalwGBi7EwC9ILln56elsuQgwPer7OmgqXKyS8imD4LIqDN4kLnRCKLkUuJ2+N3MuAgx9MwfT4bKF/VxSOAwXMb5JLrvoV2HUZ82Fg7lHJp+XpsOF/Dq1tq5zIaboztrFSeOL4OKOLwg9PcFmizPnwsDQherydLjYckrncmnyTqNyybHtcwYuzB7t0QlvnlgssPmz58LANLLsz5Uk5wIN/UbnAlezOhcEG/szBi4pCL9XaTdpNoDxkXABMN9Zd9G0uLDh4IHkstytcjFd6SpcyPh8Jb9q4JKnf6CI/r0CQq3XoZ0N/vH9GbdZgBmhG2haOuJfCTAu9LuaMmnV3U/g+3qFS9PkH0Fqi5kMuWVYAku5N8P5rgYm5pKGcdwFN5lzob5xGQI8vZbOhX0uYeKyLXzQptypNH8kXAiYjWlxATt90hZcaIihDAGeH6o6Fwg+DExc2N5ZMipnWiJcRm8+Ai7IqkyLC53Xjeq/Ci7oeYv8e5MugKRaGhe6IdypmbjAHm6I/cFmbtjr/Kp1JFymmPI7K/5lhXOVjv/Ol5Ug9aYrK+z+9E7lfPhH/x87UefG3/erOQAAAABJRU5ErkJggg=="
                                        border="0" style="width: 160px;background-color: red;padding: 10px;"></a>
                            </div>
                            <font-awesome-icon icon="fa-solid fa-user" class="pr-2" /> ชื่อคุณ {{
                                addressdelivery[0]?.Name }} {{ addressdelivery[0]?.Lastname }}
                            <br>
                            <font-awesome-icon icon="fa-solid fa-phone" class="pr-2" />เบอร์โทร {{
                                addressdelivery[0]?.Phone }}
                            <hr />
                            <br>
                            <ul>
                                <font-awesome-icon icon="fa-solid fa-address-card" class="pr-2" />ที่อยู่
                                <li v-show="addressdelivery[0]?.ProvinceName">จ.{{
                                    addressdelivery[0]?.ProvinceName }}</li>
                                <li v-show="addressdelivery[0]?.BorderName">อ.{{
                                    addressdelivery[0]?.BorderName }}</li>
                                <li v-show="addressdelivery[0]?.DistrictName">ต.{{
                                    addressdelivery[0]?.DistrictName }}</li>
                                <li v-show="addressdelivery[0]?.CountryName">ประเทศ.{{
                                    addressdelivery[0]?.CountryName }}</li>
                                <li v-show="addressdelivery[0]?.Postcode">{{ addressdelivery[0]?.Postcode }}
                                </li>
                            </ul>
                        </div>
                    </div>

                </template>
            </a-step>
            <a-step title=" จัดส่งวันที่" :description="formatdate(listproductpreview[0]?.CreatedDate)" />
            <!-- <a-step  title="สถานะ" :description="listproductpreview[0]?.Status.Name" /> -->
            <a-step title="นำจ่ายสำเร็จ" description="สำเร็จ" />
            <!-- <a-img src="https://namahayan.blob.core.windows.net/salepage/1668068170807.webp" class="w-full m-auto">
            </a-img> -->
            <a-image :preview="false" :width="auto"
                src="https://namahayan.blob.core.windows.net/salepage/1668068170807.webp" />
        </a-steps>

    </div>
</template>
<script>
import Vue3CanvasVideoPlayer from 'vue3-canvas-video-player';
import 'vue3-canvas-video-player/dist/style.css';
import TableLoad from "@/components/Skeleton/TableLoad"
import { usePagination } from "vue-request";

import { computed, defineComponent, onMounted, ref, reactive, toRefs } from "vue";
import { UserOutlined, SolutionOutlined, LoadingOutlined, SmileOutlined, VideoCameraOutlined, YoutubeOutlined } from '@ant-design/icons-vue';
import axios from "axios";
import BzbsUser from "@/core/UserManagement/callapi/BzbsUser";
// import Drawer from "./Drawer.vue";
// import Previewslip from "../component/Previewslip.vue";
import moment from "moment";
import "moment/locale/th"; // without this line it didn't work
import Util from "@/helper/Utility";
// import BarcodeGenerator from "./BarcodeGenerator.vue"; 

const queryData = params => {
    return axios.get("https://randomuser.me/api?noinfo", {
        params
    });
};

export default defineComponent({
    components: {
        TableLoad,
        UserOutlined,
        SolutionOutlined,
        LoadingOutlined,
        SmileOutlined,
        Vue3CanvasVideoPlayer,
        VideoCameraOutlined,
        YoutubeOutlined
    },

    setup() {
        const isclickdetail = ref(false)
        const addressdelivery = ref([])
        const videoPlayer = ref(null);
        const listproductpreview = ref([])
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        var track = "";
        const cuscode = ref("-")
        const current_status = ref(2)
        const iscopyfact = ref(false);
        const searchInput = ref();
        const dataSources = ref(null);
        const listtrack = ref(null);
        const rowselecteddetail = reactive({
            ishowdetail: false,
            rowselected: ""
        });

        const columns = [
            {
                title: "ลำดับ",
                dataIndex: "order",
                width: "5%"
            },
            {
                title: "ชื่อผู้รับ",
                dataIndex: "ShipAddress",
                width: "20%"
            },
            {
                title: "น้ำหนักรวมกล่อง (กรัม)",
                dataIndex: "Weight",
            },
            {
                title: "ค่าบริการ (บาท)",
                dataIndex: "ServiceCost",
                width: "10%"
            },
            {
                title: "บริการ",
                dataIndex: "StoreDeliveryOption"
            },
            {
                title: "สถานะ",
                dataIndex: "Status"
            },
            {
                title: "รหัสสิ่งของฝากส่ง",
                dataIndex: "Barcode"
            },
            {
                title: "วันที่สร้าง",
                dataIndex: "CreatedDate",
                width: "15%"
            },
            {
                title: "จ่าหน้า",
                dataIndex: "filename"
            }
        ];
        const {
            data: dataSource,
            run,
            loading,
            title = "รายการสร้างไปรษณีย์ไทย ในประเทศ",
            current,
            pageSize
        } = usePagination(queryData, {
            formatResult: res => res.data.results,
            pagination: {
                currentKey: "page",
                pageSizeKey: "results"
            }
        });
        const pagination = computed(() => ({
            total: 200,
            current: current.value,
            pageSize: pageSize.value
        }));

        const getgreencard = ref([])
        onMounted(() => {
             
            querygettrackbycuscode();
            // querycustomer();
            // queryproductpreview();
            // setTimeout(() => {
            //     playVideo()
            // }, 3000);

            // getimagegreen();
        });

        const updatedata = event => {
            if (event.updatedata) querycustomer();
        };

        const formatdate = date => {
            return moment(date)
                .add(543, "year")
                .format("L");
        };

        const querygettrackbycuscode = () => {
            if (urlParams.has('cuscode')) {
                cuscode.value = urlParams.get('cuscode');
            }
            return BzbsUser.gettrackbycuscode(cuscode.value)
                .then(res => {
                     
                    listtrack.value = res.data

                    const uniqueData = res.data?.filter(
                        (value, index, self) =>
                            index ===
                            self.findIndex(
                                t => t.AdditionalTage === value.AdditionalTage
                            )
                    ); 
                    
                    listtrack.value =  uniqueData 
                    if (listtrack.value.length == 1) {
                        getaddress(listtrack.value[0].AdditionalTage)
                    }
                    // if (dataSources[0].Status.Name?.includes("สำเร็จ")) {
                    //     current_status.value = 3
                    // }

                })
                .catch(error => {
                    console.log(error);
                });
        };
        const querycustomer = () => {
            if (urlParams.has('track')) {
                track = urlParams.get('track');
            }
            return BzbsUser.getcreatedprepostbytrack(track)
                .then(res => {

                    dataSources.value = res.data

                    if (dataSources[0].Status.Name?.includes("สำเร็จ")) {
                        current_status.value = 3
                    }

                })
                .catch(error => {
                    console.log(error);
                });
        };
        const queryproductpreview = (sp) => {
            return BzbsUser.getcreatedeliverybycustomerid(sp)
                .then(res => {
                    listproductpreview.value = res.data
                    isclickdetail.value = true

                })
                .catch(error => {
                    console.log(error);
                });
        };
        const getimagegreen = () => {
            if (urlParams.has('track')) {
                track = urlParams.get('track');
            }
            return BzbsUser.getimagegreen(track)
                .then(res => {
                    getgreencard.value = res.data;
                })
                .catch(error => {
                    console.log(error);
                });
        };
        const handleTableChange = (pag, filters, sorter) => {
            run({
                results: pag.pageSize,
                page: pag?.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters
            });
        };
        const rowselected = record => {
            rowselecteddetail.rowselected = record[0].CustomerOrder;
            rowselecteddetail.ishowdetail = true;
            console.log(record[0].CustomerOrder);
        };
        const state = reactive({
            searchText: '',
            searchedColumn: '',
        });
        const handleSearch = (selectedKeys, confirm, dataIndex) => {
            confirm();

            state.searchText = selectedKeys[0];
            state.searchedColumn = dataIndex;
        };
        const handleReset = clearFilters => {
            clearFilters({
                confirm: true,
            });
            state.searchText = '';
        };
        const getdatagreen = json => {

            return JSON.parse(JSON.stringify(json));
        };
        const iscopy = () => {

            iscopyfact.value = true

        }

        const playVideo = () => {
            if (videoPlayer.value) {
                videoPlayer.value.play();
            }
        };

        const getaddress = (sp) => {
            window.location = "/consumerdeliverydetail?cuscode=" + cuscode.value + '&sp=' + sp
            if (isclickdetail.value == true) {
                isclickdetail.value = false
            }
             
            if (urlParams.has('cuscode')) {
                cuscode.value = urlParams.get('cuscode');
            }
            return BzbsUser.getaddressbysp(cuscode.value, sp)
                .then(res => {

                     
                    addressdelivery.value = res.data
                    queryproductpreview(sp)


                })
                .catch(error => {
                    console.log(error);
                });

        }
        return {
            videoPlayer,
            playVideo,
            iscopy,
            iscopyfact,
            getgreencard,
            current_status,
            handleSearch,
            handleReset,
            rowselecteddetail,
            rowselected,
            dataSource,
            dataSources,
            pagination,
            loading,
            title,
            columns,
            handleTableChange,
            querycustomer,
            formatdate,
            updatedata,
            searchInput,
            ...toRefs(state),
            Util,
            getdatagreen,
            listproductpreview,
            listtrack,
            getaddress,
            addressdelivery,
            isclickdetail
        };
    }
});
</script>
<style lang="scss">
.wrapper-track {
    width: 100%;
    max-width: 450px;
    margin: auto;

    .ant-steps-item-process .ant-steps-item-icon {
        background-color: #fff;
        border-color: #ae8b40 !important;
    }

    .ant-steps-item-process>.ant-steps-item-container>.ant-steps-item-icon {
        background: #ae8b40 !important;
    }

    .ant-steps-item-finish .ant-steps-item-icon {
        background-color: #fff;
        border-color: #ae8b40 !important;
    }

    .ant-steps-item-tail::after {
        background-color: #ae8b40 !important;
    }

    .green-table {
        font-family: 'Arial, Helvetica, sans-serif';
        font-size: 14px;
        color: #FFFFFF;
        border: 1px solid #CCCCCC;
        padding-left: 0px;
        text-align: center;
        background-image: -webkit-gradient(linear, left top, left bottom, from(#ccffcc), to(#99cccc));
        background: -moz-linear-gradient(top, #ccffcc, #99cccc);
        filter: progid:DXImageTransform.Microsoft.Gradient(GradientType=0, StartColorStr=#ccffcc, EndColorStr=#99cccc);
    }

    .ant-steps-vertical>.ant-steps-item .ant-steps-item-icon {
        float: left;
        margin-right: 10px;
    }

    .namegreen {
        position: absolute;
        color: rgb(255 255 255 / 30%);
        font-size: 37px;
        top: 45%;
        left: 15px;
        text-align: center;
        font-weight: bold;
        width: 100%;
        pointer-events: none;
        -webkit-transform: rotate(-45deg);
        font-family: tahoma;
    }
}

.ant-typography {
    margin-bottom: 0px !important;
}

.ant-steps-item-title {
    font-size: 14px !important;
}

.video-preview {
    position: relative;
    display: inline-block;
}

.play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    background: url('../../../assets/yt.svg') no-repeat center center;
    background-size: 60%;
    opacity: 0.8;
    cursor: pointer;
}
</style>
